import { useHistory, useLocation } from "react-router-dom";

/**
 * Syncs a page's active tab to a `?tab=<value>` query param so the selection
 * survives reloads and back/forward navigation. Selecting a tab replaces the
 * URL and preserves other query params.
 */
export const useUrlTab = (
  defaultTab: string
): { activeTab: string; onTabSelect: (tab: string | number) => void } => {
  const history = useHistory();
  const { pathname, search } = useLocation();

  const activeTab = new URLSearchParams(search).get("tab") ?? defaultTab;

  const onTabSelect = (tab: string | number): void => {
    const params = new URLSearchParams(search);
    params.set("tab", String(tab));
    history.replace(`${pathname}?${params.toString()}`);
  };

  return { activeTab, onTabSelect };
};
